import update from "immutability-helper";
import {
  IS_NETWORK_CONNECTED,
  SHOW_APPLE_INSTALLATION_INFO,
  REHYDRATE_WITH_SESSION_STORAGE,
  SET_PRIVACY_ACCEPTED,
  FETCH_OSPEDALI_SUCCESS,
} from "./index";

export const initialState = {
  networkConnected: window.navigator.onLine,
  showAppleInstallationDrawer: null,
  privacyAccepted: false,
  ospedali: {
    data: null,
    fetchEnded: false,
  },
};

const networkConnectedHandler = (state, action) => {
  return update(state, {
    networkConnected: { $set: action.isConnected },
  });
};

const showAppleInstallationInfoHandler = (state, action) => {
  return update(state, {
    showAppleInstallationDrawer: { $set: action.value },
  });
};

const rehydrateWithSessionStorageHandler = (state, action) => {
  return update(state, { $set: action.sessionStorageValues });
};

const setPrivacyAcceptedHandler = (state, action) => {
  return update(state, {
    privacyAccepted: { $set: action.value },
  });
};

const fetchOspedaliSuccessHandler = (state, action) => {
  return update(state, {
    ospedali: {
      data: { $set: action.ospedali },
      fetchEnded: { $set: true },
    },
  });
};

const rehydrateStoreHandler = (state, action) => {
  if (action.payload !== undefined) return update(state, { $set: action.payload.common });
  else return state;
};

export const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_NETWORK_CONNECTED:
      return networkConnectedHandler(state, action);
    case SHOW_APPLE_INSTALLATION_INFO:
      return showAppleInstallationInfoHandler(state, action);
    case REHYDRATE_WITH_SESSION_STORAGE:
      return rehydrateWithSessionStorageHandler(state, action);
    case SET_PRIVACY_ACCEPTED:
      return setPrivacyAcceptedHandler(state, action);
    case FETCH_OSPEDALI_SUCCESS:
      return fetchOspedaliSuccessHandler(state, action);
    case "persist/REHYDRATE":
      return rehydrateStoreHandler(state, action);
    default:
      return state;
  }
};
